import React from "react";
import "./About.css";
import "../../utilities/common.css";
import aboutMedia from "../../media/Profile-Photo.jpg";

class About extends React.Component {
  render() {
    return (
      <section className="About site-content">
        <div className="card" id="about-media-card-side">
          <img src={aboutMedia} />
        </div>
        <div className="about-info-wrapper">
          <div className="card" id="about-main-card">
            <h1>
              Nice to meet you!
              <div className="badge">About Me</div>
            </h1>
            <p>
              My name's Ethan. I love building experiences for others to enjoy.
              Whether it's through a piece of software or art, my greatest joy
              is expressing myself. That's why I'm both a programmer and an
              artist; I cherish the whole process of creation!
            </p>
            <p>
              I'm a <b>software engineer</b>, with experience in apps, websites,
              and general software. For web development, I'm a{" "}
              <b>full stack developer</b> and a <b>full stack designer</b>. I
              love doing it all, but my primary expertise is in programming.
            </p>
            <div className="skills-wrapper">
              <p>
                <b>Languages:</b> JavaScript, C++, Java
              </p>
              <p>
                <b>Technologies:</b> Node, React, SQL
              </p>
            </div>
          </div>
          <div className="card" id="about-media-card-mid">
            <img src={aboutMedia} alt="Profile Photo" />
          </div>
          <div className="about-sub-wrapper">
            <div className="card card-top" id="education-card">
              <h2>Education</h2>
              <p>
                2016-2020 <br />
                <b>University of Pittsburgh, Pittsburgh, PA</b> <br />
                Bachelor of Science in Computer Science <br />
                Minor in Studio Arts, Minor in Philosophy <br />
                Graduated <i>summa cum laude</i>
              </p>
            </div>
            <div className="card card-top" id="interests-card">
              <h2>Interests</h2>
              <p>
                Archery • Rock Climbing • Game Dev <br />
                Illustration • Painting • Pixel Art <br />
                Animation • Graphic Design • 3D Art <br />
                Philosophy • Reading • Language <br />
                Politics • Piano • Guitar • Percussion
              </p>
            </div>
          </div>
        </div>
      </section>
    );
  }
}

export default About;
